// src/components/issues/PastilleNcs.tsx — SCE Issues
// « NC-S » (ou son N°, « NC-S_2026-97 ») en petit, dans les lignes de l'accueil
// et de la fenêtre de liste (06/10) : dans la file « À qualifier », le
// coordinateur voit qu'une NC-S est déjà partie à la qualité. Même dessin que
// le badge de traitement qualité (contour noir), à la taille d'une ligne.

import type { JSX } from 'react'
import { libelleBadge, type Issue } from '@/types/issue.types'

/** Le problème a une NC-S (envoyée, ou prévue) et n'est pas annulé. */
export function aUneNcs(issue: Pick<Issue, 'badgesCloture' | 'statut'>): boolean {
  return issue.statut !== 'Annulé' && (issue.badgesCloture?.includes('NC-S') ?? false)
}

export function PastilleNcs({ issue }: { issue: Pick<Issue, 'badgesCloture' | 'statut' | 'refNcs' | 'refFnct'> }): JSX.Element | null {
  if (!aUneNcs(issue)) return null
  const libelle = libelleBadge(issue, 'NC-S')
  return (
    <span
      title={libelle === 'NC-S' ? 'NC-S envoyée à la qualité, N° pas encore connu' : `NC-S ${libelle}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 17,
        padding: '0 5px',
        marginRight: 6,
        borderRadius: 4,
        border: '1px solid var(--color-black)',
        backgroundColor: 'var(--color-white)',
        color: 'var(--color-black)',
        fontSize: 10.5,
        fontWeight: 600,
        letterSpacing: 0.2,
        verticalAlign: 'middle',
        flexShrink: 0,
      }}
    >
      {libelle}
    </span>
  )
}
